export const doesSlugExistInSubCategories = (subCategories: any[], slugToMatch: string): boolean => {
  for (const subCategory of subCategories) {
    if (subCategory.slug === slugToMatch) return true;
    if (subCategory.subCategories?.length > 0) {
      if (doesSlugExistInSubCategories(subCategory.subCategories, slugToMatch)) return true;
    }
  }
  return false;
};

export const isLinkMatchingSubCategory = (linkReferenceLink: string, categories: any[]): boolean => {
  const slug = linkReferenceLink.split('/').filter(Boolean).pop() || linkReferenceLink;
  return categories.some(
    (category) => category.subCategories?.length > 0 && doesSlugExistInSubCategories(category.subCategories, slug),
  );
};

export const findCategoryBySlug = (slug: string, categoriesList: any[]): any | null => {
  for (const category of categoriesList) {
    if (category.slug === slug) return category;
    if (category.subCategories?.length > 0) {
      const found = findCategoryBySlug(slug, category.subCategories);
      if (found) return found;
    }
  }
  return null;
};
